function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import PictureComponent from "/components/core/picture/picture-component";
import { StyledHeaderWithImageAndTitleComponent } from "./header-with-image-and-title-component.scss";
import colors from "/styles/colors";
class HeaderWithImageAndTitleComponent extends PureComponent {
    render() {
        const { signupForm, backgroundColor, hotdog, title, subtitle, image, textColor, imageWidth, useTemplateButton } = this.props;
        return /*#__PURE__*/ _jsxs(StyledHeaderWithImageAndTitleComponent, {
            imageWidth: imageWidth,
            hotDogColor: backgroundColor,
            className: "header-with-image-and-title-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "hot-dog",
                    style: {
                        backgroundColor: colors[backgroundColor]
                    }
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: classnames("header-with-image-content", {
                        "white-text": textColor === "white"
                    }),
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        subtitle && /*#__PURE__*/ _jsx("h2", {
                            className: "subtitle",
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        }),
                        signupForm && /*#__PURE__*/ _jsx("div", {
                            className: "signup-form",
                            children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                                focusOnLoad: true
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("main-image", {
                                "with-shadow": image.shadow
                            }),
                            children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, image))
                        })
                    ]
                })
            ]
        });
    }
}
export { HeaderWithImageAndTitleComponent as default };
HeaderWithImageAndTitleComponent.defaultProps = {
    backgroundColor: "brand-purple",
    image: {},
    title: "",
    subtitle: "",
    signupForm: true,
    textColor: "",
    imageWidth: "50%"
};
